const getSelectFilesMessage = (multi) =>
  multi ? 'Select files' : 'Select file'

const getDragFilesMessage = (multi) =>
  multi ? 'Drag and drop files here' : 'Drag and drop file here'

const messages = {
  or: 'Or',
  getSelectFilesMessage,
  getDragFilesMessage,
}
export default messages
